import { Line } from "react-chartjs-2";
import { useRecoilValue } from "recoil";
import { useGetOfficeStates } from "../../CarrierAgreementMgmt/OfficeSettings/hooks/useGetOfficeStates";
import { accountAtom } from "../../Login/atoms/AccountAtom";

export default function OfficeChart() {
  const { data: officeState } = useGetOfficeStates();
  const user = useRecoilValue(accountAtom);
  const superUser = user?.isFranchise && user?.isNonFranchise;
  const franchise = user?.isFranchise && !user?.isNonFranchise;
  const officeData = {
    labels: officeState?.result
      ?.map((x) => x.states)
      .sort((a, b) => (a.toLowerCase() > b.toLowerCase() ? 1 : -1)),
    datasets: [
      {
        // label: "Confie",
        data: officeState?.result?.map((x) => x.confie),
        backgroundColor: "#0078D7",
        borderColor: "#0078D7",
        pointerBorderWidth: 1,
        tension: 0.5,
        borderWidth: 1,
        hoverBorderWidth: 3,
        pointRadius: 2,
      },
      {
        // label: "Franchise",
        data: officeState?.result?.map((x) => x.franchise),
        backgroundColor: "#EC4899",
        borderColor: "#EC4899",
        pointerBorderWidth: 4,
        tension: 0.5,
        borderWidth: 1,
        hoverBorderWidth: 3,
        pointRadius: 2,
      },
    ],
  };

  const confieData = {
    labels: officeState?.result
      ?.map((x) => x.states)
      .sort((a, b) => (a.toLowerCase() > b.toLowerCase() ? 1 : -1)),
    datasets: [
      {
        // label: "Confie",
        data: officeState?.result?.map((x) => x.confie),
        backgroundColor: "#0078D7",
        borderColor: "#0078D7",
        pointerBorderWidth: 1,
        tension: 0.5,
        borderWidth: 1,
        hoverBorderWidth: 3,
        pointRadius: 2,
      },
    ],
  };
  const franchiseData = {
    labels: officeState?.result
      ?.map((x) => x.states)
      .sort((a, b) => (a.toLowerCase() > b.toLowerCase() ? 1 : -1)),
    datasets: [
      {
        // label: "Franchise",
        data: officeState?.result?.map((x) => x.franchise),
        backgroundColor: "#EC4899",
        borderColor: "#EC4899",
        pointerBorderWidth: 4,
        tension: 0.5,
        borderWidth: 1,
        hoverBorderWidth: 3,
        pointRadius: 2,
      },
    ],
  };
  return (
    <div>
      <div className="grid grid-cols-2 items-center">
        <h1 className="mt-1 mb-4 text-sm text-tertiary font-semibold">
          Office Open Status per State
        </h1>
      </div>
      <Line
        className="flex items-center"
        data={superUser ? officeData : franchise ? franchiseData : confieData}
        options={{
          responsive: true,
          // maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
              position: "bottom",
              align: "center",
              labels: {
                usePointStyle: true,
              },
            },
          },
          scales: {
            x: {
              ticks: {
                autoSkip: false,
                font: {
                  size: 8.5,
                },
              },
              grid: {
                display: false,
              },
            },
            y: {
              grid: { display: false, color: "#F0F0F0" },
              beginAtZero: true,
              // max: 100,
              // min: -50,
              ticks: {
                color: "#A3A3A3",
                font: {
                  size: 9,
                },
                stepSize: 20,
              },
            },
          },
        }}
        height={100}
        width={420}
      />
      <div className="flex items-center gap-2 m-2 justify-center flex-row">
        {superUser ? (
          <>
            <div className="flex flex-row items-center">
              <div className="h-2 w-2 rounded-md bg-tabColorDarkBlue m-1" />
              <div className="inline-block text-xs4 font-normal">Confie</div>
            </div>

            <div className="flex flex-row items-center">
              <div className="h-2 w-2 rounded-md bg-hsecondary m-1" />
              <div className="inline-block text-xs4 font-normal">Franchise</div>
            </div>
          </>
        ) : franchise ? (
          <div className="flex flex-row items-center">
            <div className="h-2 w-2 rounded-md bg-hsecondary m-1" />
            <div className="inline-block text-xs4 font-normal">Franchise</div>
          </div>
        ) : (
          <div className="flex flex-row items-center">
            <div className="h-2 w-2 rounded-md bg-tabColorDarkBlue m-1" />
            <div className="inline-block text-xs4 font-normal">Confie</div>
          </div>
        )}
      </div>
    </div>
  );
}
